/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnDestroy, OnInit } from '@angular/core';

import { Subscription } from 'rxjs';

import { CoreConfigService } from '@xbaht/ui/core/services';

import { environment } from 'environments/environment';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[xbaht-footer]',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  standalone: false
})
export class FooterComponent implements OnInit, OnDestroy {
  public environment = environment;

  public coreConfig: any;
  public year: number = new Date().getFullYear();

  private _unsubscribes: Subscription[] = [];

  constructor(public _coreConfigService: CoreConfigService) {}

  ngOnInit(): void {
    this._coreConfigService.config.subscribe((config: any) => {
      this.coreConfig = config;
    });
  }

  ngOnDestroy(): void {
    this._unsubscribes.forEach((_) => _.unsubscribe());
  }
}
